// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
			|| window[vendors[x] + 'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() {
					callback(currTime + timeToCall);
				},
				timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}

	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
	}
}());

//classlist polyfill:
//https://github.com/remy/polyfills/blob/master/classList.js
(function() {

	if (typeof window.Element === "undefined" || "classList" in document.documentElement) {
		return;
	}

	var prototype = Array.prototype,
		push = prototype.push,
		splice = prototype.splice,
		join = prototype.join;

	function DOMTokenList(el) {
		this.el = el;
		// The className needs to be trimmed and split on whitespace
		// to retrieve a list of classes.
		var classes = [];
		try {
			var classes = el.className.replace(/^\s+|\s+$/g, '').split(/\s+/);
			for (var i = 0; i < classes.length; i++) {
				push.call(this, classes[i]);
			}
		} catch (e) {
			console.log(e);
		}
	}

	DOMTokenList.prototype = {
		add: function(token) {
			if (this.contains(token)) {
				return;
			}
			push.call(this, token);
			this.el.className = this.toString();
		},
		contains: function(token) {
			return this.el.className.indexOf(token) != -1;
		},
		item: function(index) {
			return this[index] || null;
		},
		remove: function(token) {
			if (!this.contains(token)) {
				return;
			}
			for (var i = 0; i < this.length; i++) {
				if (this[i] == token) {
					break;
				}
			}
			splice.call(this, i, 1);
			this.el.className = this.toString();
		},
		toString: function() {
			return join.call(this, ' ');
		},
		toggle: function(token) {
			if (!this.contains(token)) {
				this.add(token);
			} else {
				this.remove(token);
			}

			return this.contains(token);
		}
	};

	window.DOMTokenList = DOMTokenList;

	function defineElementGetter(obj, prop, getter) {
		if (Object.defineProperty) {
			Object.defineProperty(obj, prop, {
				get: getter
			});
		} else {
			obj.__defineGetter__(prop, getter);
		}
	}

	defineElementGetter(Element.prototype, 'classList', function() {
		return new DOMTokenList(this);
	});

})();

//60 fps scroll, if true kjører den
if (typeof initFPSscroll !== 'undefined' ? initFPSscroll : false) {
	(function e(t, n, r) {
		function s(o, u) {
			if (!n[o]) {
				if (!t[o]) {
					var a = typeof require == "function" && require;
					if (!u && a) {
						return a(o, !0);
					}
					if (i) {
						return i(o, !0);
					}
					throw new Error("Cannot find module '" + o + "'")
				}
				var f = n[o] = {exports: {}};
				t[o][0].call(f.exports, function(e) {
					var n = t[o][1][e];
					return s(n ? n : e)
				}, f, f.exports, e, t, n, r)
			}
			return n[o].exports
		}

		var i = typeof require == "function" && require;
		for (var o = 0; o < r.length; o++) {
			s(r[o]);
		}
		return s
	})({
		1: [
			function(require, module, exports) {
				"use strict";
				var support = require("./utils").support;
				var dispatchClick = require("./utils").dispatchClick;
				if (typeof document.addEventListener !== 'function') {
					return;
				}
				document.addEventListener('DOMContentLoaded', function() {
					if (!support) {
						return;
					}
					var cover = document.createElement('div'), body = document.body, coverStyle = cover.style,
						scrollStarted = false, timer, clicked = false, pos = {x: 0, y: 0};
					coverStyle.cssText = ['-webkit-transform: translate3d(0,0,0);', 'transform: translate3d(0,0,0);', 'position: fixed;', 'top: 0;', 'right: 0;', 'left: 0;', 'bottom: 0;', 'opacity: 0;', 'z-index: 2147483647;', 'pointer-events: none'].join('');
					body.appendChild(cover);
					window.addEventListener('scroll', function scroll() {
						if (!scrollStarted) {
							coverStyle.pointerEvents = 'auto';
							scrollStarted = true;
						}
						clearTimeout(timer);
						timer = setTimeout(function() {
							coverStyle.pointerEvents = 'none';
							scrollStarted = false;
							if (clicked) {
								dispatchClick(pos);
								clicked = false;
							}
						}, 300);
					}, false);
					document.addEventListener('click', function clickCatcher(event) {
						if (event.target === cover && !event.synthetic) {
							pos.x = event.clientX;
							pos.y = event.clientY;
							clicked = true;
						}
					}, false);
				}, false);
			}, {"./utils": 2}
		], 2: [
			function(require, module, exports) {
				"use strict";
				var support = (function support() {
					var element = document.createElement('x');
					element.style.cssText = 'pointer-events:auto';
					return element.style.pointerEvents === 'auto';
				}());

				function dispatchClick(coords) {
					var event = document.createEvent('MouseEvent'),
						elem = document.elementFromPoint(coords.x, coords.y);
					event.initMouseEvent('click', true, true, window, null, coords.x, coords.y, 0, 0, false, false, false, false, 0, null);
					event.synthetic = true;
					elem.dispatchEvent(event);
				}

				exports.support = support;
				exports.dispatchClick = dispatchClick;
			}, {}
		]
	}, {}, [1])
}
